<template>
  <swiper
    :slidesPerView="1"
    :navigation="true"
    :pagination="{
      type: 'progressbar',
    }"
    :breakpoints="{
      '0': {
        slidesPerView: 1,
      },
      '830': {
        slidesPerView: 2,
      },
      '1255': {
        slidesPerView: 3,
      },
      '1670': {
        slidesPerView: 4,
      },
      '2100': {
        slidesPerView: 5,
      },
    }"
    class="swiper form-swiper pb-1 mb-3"
    :data-length="filters.length"
  >
    <swiper-slide v-for="(filter, index) in filters" :key="index">
      <button
        type="button"
        :class="[{ selected: filter.isSelected }, 'btn prefilters-filter']"
        @mousedown="preventFocus"
        @click="selectItem(filter)"
      >
        <picture v-if="filter.image">
          <v-lazy-image
            class="img-fluid"
            :src="filter.image"
            src-placeholder="/public/img/placeholder.gif?mode=crop&width=360&height=360"
            width="360"
            height="360"
            alt=""
          />
        </picture>
        <picture v-else>
          <img
            class="img-fluid"
            src="/public/img/placeholder.gif?mode=crop&width=360&height=360"
            width="360"
            height="360"
            alt=""
          />
        </picture>
        <span class="prefilters-filter__checkmark">+</span>
        <span class="prefilters-filter__text text-shadow">{{
          filter.name
        }}</span>
      </button>
    </swiper-slide>
  </swiper>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import VLazyImage from "v-lazy-image";

import "swiper/css";
import "swiper/css/pagination";

// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper";

// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

export default {
  name: "PreFilterSwiper",
  props: ["filters"],
  components: {
    Swiper,
    SwiperSlide,
    VLazyImage,
  },
  methods: {
    selectItem: function (filter) {
      filter.isSelected = !filter.isSelected;
      this.$store.dispatch("selectItem", filter.id);
    },
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
  },
};
</script>